import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getActionItemsSuccess: ["response"],
  getActionItemsFailure: ["error"],
  getActionItemsRequest: ["data"],

  setUserState: ["key", "value"],
});

export const getUserTypes = Types;

export const getUserAction = Creators;

export const INITIAL_STATE = {
  error: null,
  isLoading: false,
  userData: null,
  isSuccess: false,
  isDialogOpen: false,
};

export const getActionItemsRequest = (state: any) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const getActionItemsSuccess = (state: any, action: any) => {
  const response = action.response;
  if (response) {
    return {
      ...state,
      error: null,
      userData: response.data,
      isLoading: false,
      isSuccess: true,
    };
  }
  return {
    ...state,
    isLoading: false,
  };
};

export const getActionItemsFailure = (state: any, action: any) => {
  return {
    ...state,
    isLoading: false,
    isSuccess: false,
    error: action.error.message,
  };
};

export const setUserState = (state: any, action: any) => {
  const newState = {
    ...state,
  };
  newState[action.key] = action.value;
  return newState;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ACTION_ITEMS_SUCCESS]: getActionItemsSuccess,
  [Types.GET_ACTION_ITEMS_FAILURE]: getActionItemsFailure,
  [Types.GET_ACTION_ITEMS_REQUEST]: getActionItemsRequest,

  [Types.SET_USER_STATE]: setUserState,
});
